




































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'unlock-input' })
export default class UnlockInput extends Vue {
    password: string = ''

    @Prop({ type: String })
    errorMessage: string|null = null

    @Prop({ type: Boolean, default: false })
    loading!: boolean

    get incorrect(): boolean {
        return this.errorMessage !== null
    }

    submit(): void {
        this.$emit('submit', this.password)
    }

    input(): void {
        this.$emit('input', this.password)
    }
}
